module.exports = __webpack_public_path__ + "static/media/FHA_Construction_Home_Loans.17b2b9cc.png";